<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
  },
}
</script>

<style>
#app {
  //font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: system-ui, -apple-system, Helvetica, Arial, sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue